<template>
  <div class="notify-page">
    <div class="nt-header">
      <h1>消息通知</h1>
      <button v-if="hasUnread" class="mark-all" @click="markAll">全部已读</button>
    </div>

    <!-- 分类筛选 -->
    <div class="nt-tabs">
      <div
        v-for="t in tabs"
        :key="t.key"
        class="nt-tab"
        :class="{ active: activeTab === t.key }"
        @click="switchTab(t.key)"
      >
        {{ t.label }}
      </div>
    </div>

    <div v-if="loading" class="nt-loading">加载中…</div>

    <div v-else-if="list.length === 0" class="nt-empty">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>
      <p>暂无通知</p>
    </div>

    <div v-else class="nt-list">
      <div
        v-for="n in list"
        :key="n.id"
        class="nt-item"
        :class="{ unread: !n.is_read }"
        @click="openItem(n)"
      >
        <div class="nt-icon" :class="'ic-' + n.type">
          <svg v-if="n.type === 'audit'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>
          <svg v-else-if="n.type === 'unlock'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 9.9-1"/></svg>
          <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>
        </div>
        <div class="nt-body">
          <div class="nt-top">
            <span class="nt-title">{{ n.title }}</span>
            <span class="nt-time">{{ formatTime(n.createtime) }}</span>
          </div>
          <p class="nt-content">{{ n.content }}</p>
        </div>
        <span v-if="!n.is_read" class="nt-unread-dot"></span>
      </div>

      <button v-if="hasMore" class="load-more" @click="loadMore" :disabled="loadingMore">
        {{ loadingMore ? '加载中…' : '加载更多' }}
      </button>
    </div>
  </div>
</template>

<script>
import { getNotifications, markNoticeRead, markAllNoticeRead } from '../api/index';

export default {
  name: 'NotificationsPage',
  data() {
    return {
      loading: true,
      loadingMore: false,
      activeTab: 'all',
      tabs: [
        { key: 'all', label: '全部' },
        { key: 'system', label: '系统' },
        { key: 'audit', label: '投稿审核' },
        { key: 'unlock', label: '解锁提醒' }
      ],
      list: [],
      page: 1,
      limit: 15,
      total: 0
    };
  },
  computed: {
    hasUnread() {
      return this.list.some(n => !n.is_read);
    },
    hasMore() {
      return this.list.length < this.total;
    }
  },
  mounted() {
    this.loadList(true);
  },
  methods: {
    async loadList(reset = false) {
      if (reset) {
        this.page = 1;
        this.loading = true;
      }
      try {
        const res = await getNotifications({ page: this.page, limit: this.limit, type: this.activeTab });
        if (res.data && res.data.code === 1) {
          const data = res.data.data || {};
          const items = data.list || [];
          this.total = data.total || items.length;
          this.list = reset ? items : [...this.list, ...items];
        }
      } catch (e) {
        console.warn('通知列表获取失败', e);
        if (reset) this.list = [];
      } finally {
        this.loading = false;
        this.loadingMore = false;
      }
    },
    switchTab(key) {
      if (this.activeTab === key) return;
      this.activeTab = key;
      this.loadList(true);
    },
    async loadMore() {
      this.loadingMore = true;
      this.page += 1;
      await this.loadList(false);
    },
    async openItem(n) {
      if (!n.is_read) {
        try {
          await markNoticeRead(n.id);
          n.is_read = 1;
        } catch (e) { /* 忽略 */ }
      }
      // 审核类通知可跳转到我的投稿
      if (n.type === 'audit') {
        this.$router.push('/submission');
      } else if (n.link) {
        this.$router.push(n.link);
      }
    },
    async markAll() {
      try {
        await markAllNoticeRead();
        this.list.forEach(n => { n.is_read = 1; });
      } catch (e) {
        alert('操作失败，请稍后重试');
      }
    },
    formatTime(ts) {
      if (!ts) return '';
      const t = typeof ts === 'number' ? ts * 1000 : new Date(ts).getTime();
      const diff = Date.now() - t;
      const min = Math.floor(diff / 60000);
      if (min < 1) return '刚刚';
      if (min < 60) return `${min}分钟前`;
      const h = Math.floor(min / 60);
      if (h < 24) return `${h}小时前`;
      const d = Math.floor(h / 24);
      if (d < 30) return `${d}天前`;
      const date = new Date(t);
      return `${date.getMonth() + 1}-${date.getDate()}`;
    }
  }
};
</script>

<style scoped>
.notify-page { max-width: 760px; margin: 0 auto; color: var(--text); }
.nt-header { display: flex; align-items: center; justify-content: space-between; }
.nt-header h1 { font-size: 24px; font-weight: 700; }
.mark-all {
  background: var(--brand-soft); color: var(--brand); border: none; cursor: pointer;
  padding: 8px 14px; border-radius: 10px; font-size: 13px; font-weight: 600;
}
.mark-all:hover { background: var(--brand-soft-strong); }

.nt-tabs { display: flex; gap: 8px; margin: 20px 0; flex-wrap: wrap; }
.nt-tab {
  padding: 7px 16px; border-radius: var(--radius-pill); cursor: pointer;
  font-size: 13px; background: var(--surface-2); color: var(--text-dim); border: 1px solid var(--border);
  transition: background var(--t-fast), color var(--t-fast);
}
.nt-tab:hover { color: var(--text); }
.nt-tab.active { background: var(--brand-soft); color: var(--brand); border-color: transparent; }

.nt-loading, .nt-empty { text-align: center; padding: 60px 0; color: var(--text-dim); }
.nt-empty svg { width: 48px; height: 48px; opacity: .4; margin-bottom: 12px; }

.nt-list { display: flex; flex-direction: column; gap: 10px; }
.nt-item {
  display: flex; align-items: flex-start; gap: 14px; position: relative;
  background: var(--surface); border: 1px solid var(--border); border-radius: var(--radius);
  padding: 16px; cursor: pointer; transition: border-color var(--t-fast);
}
.nt-item:hover { border-color: var(--border-strong); }
.nt-item.unread { background: var(--surface-2); }

.nt-icon {
  flex-shrink: 0; width: 40px; height: 40px; border-radius: 10px;
  display: flex; align-items: center; justify-content: center;
  background: var(--brand-soft); color: var(--brand);
}
.nt-icon svg { width: 20px; height: 20px; }
.nt-icon.ic-audit { background: rgba(52,211,153,.12); color: var(--success); }
.nt-icon.ic-unlock { background: rgba(229,185,104,.14); color: var(--gold); }

.nt-body { flex: 1; min-width: 0; }
.nt-top { display: flex; align-items: baseline; justify-content: space-between; gap: 10px; }
.nt-title { font-size: 14px; font-weight: 600; color: var(--text); }
.nt-time { font-size: 12px; color: var(--text-faint); flex-shrink: 0; }
.nt-content { font-size: 13px; color: var(--text-dim); margin-top: 5px; line-height: 1.6; }

.nt-unread-dot {
  position: absolute; top: 16px; right: 16px;
  width: 8px; height: 8px; border-radius: 50%; background: var(--danger);
}

.load-more {
  margin-top: 8px; padding: 12px; background: var(--surface-2); border: 1px solid var(--border);
  border-radius: var(--radius); color: var(--text-dim); cursor: pointer; font-size: 13px;
}
.load-more:hover { color: var(--text); }
</style>
